export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Download & Install',
      description: 'Download the SALVI VPN application from our website or app store. Installation takes just a few minutes and works on all major platforms including Windows, Mac, iOS, and Android.',
      icon: 'ri-download-cloud-line'
    },
    {
      number: '02',
      title: 'Create Your Account',
      description: 'Sign up with your email address and create a secure password. No personal information required. Your privacy starts from the moment you register with our VPN service.',
      icon: 'ri-user-add-line'
    },
    {
      number: '03',
      title: 'Connect & Browse Safely',
      description: 'Choose a server location from our global network and click connect. Your internet connection is now encrypted and secure. Browse, stream, and download with complete peace of mind.',
      icon: 'ri-shield-check-line'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Get Started in <strong>3 Simple Steps</strong>
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Setting up your VPN protection is quick and easy. Follow these simple steps to secure your online privacy in minutes.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300">
                <div className="flex items-start mb-6">
                  <div className="w-16 h-16 flex items-center justify-center bg-teal-600 rounded-xl mr-4 flex-shrink-0">
                    <i className={`${step.icon} text-3xl text-white`}></i>
                  </div>
                  <div className="text-6xl font-bold text-teal-100">
                    {step.number}
                  </div>
                </div>
                
                <h4 className="text-2xl font-bold text-gray-900 mb-4">
                  <strong>{step.title}</strong>
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-4xl text-teal-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-teal-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-all shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            Start Your Secure Journey
          </button>
        </div>
      </div>
    </section>
  );
}
